import { useContext, useMemo } from 'react'
import TrackerImpl, { Tracker } from './Tracker'
import TrackingContext from './TrackingContext'

const useTracking = () => useContext(TrackingContext)

export default useTracking

let _tracker = null

const useInitTracking = (options) => {
  const tracker: Tracker = useMemo(() => {
    if (typeof window === 'undefined') return null

    if (!_tracker) {
      _tracker = new TrackerImpl(options)
    }
    return _tracker
  }, [])

  return {
    tracker
  }
}

export { useInitTracking }
